import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  summaryCard: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  titleMarginBottom: {
    marginBottom: theme.spacing(2),
  },
  businessCards: {
    padding: `${theme.spacing(4)} ${theme.spacing(2)}`,
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    borderBottom: `5px solid ${theme.palette.grey[200]}`,
    marginBottom: theme.spacing(4),
  },
}));

const useHeadSquareStyles = makeStyles({
  score: {
    fontWeight: 500,
    fontSize: 60,
  },
  max: {
    fontSize: 24,
  },
  scoreWidgetMainColumn: {
    height: '100%',
  },
});

export { useStyles, useHeadSquareStyles };
